<template>
    <div :class="bgWhite ? 'bg-white shadow-md' : ''" class="rounded pb-1">
        <header class="px-6 py-4 flex items-center border-b-2 border-gray-200">
            <slot name="header"></slot>
        </header>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        bgWhite: {
            required: false,
            type: Boolean,
            default: true
        },
    },
}
</script>
